import { render, staticRenderFns } from "./SchoolInfoForm.vue?vue&type=template&id=e6bdddc8&scoped=true&"
import script from "./SchoolInfoForm.vue?vue&type=script&lang=js&"
export * from "./SchoolInfoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6bdddc8",
  null
  
)

export default component.exports